<template>
    <div style="width: 100%; height: 100%; text-align: left; overflow-y: auto; overflow-x: auto;">
        <v-treeview
                open-all
                :activatable="false"
                :hoverable="true"
                :items="itemsSafe"
                :open-on-click="true"
                :rounded="true"
                :selectable="false"
                @input="val=>this.itemModel=val"
                @update:active="val=>this.itemActive=val"
                @update:open="val=>this.itemOpen=val"
                :search="search"
                color="primary"
                dense
                selected-color="success"
        >
            <template #label="{ item, leaf, selected, indeterminate, active, open, }">
                <template v-if="item.deleted()">
                    <span style="color: #ddd; text-decoration: line-through;">{{ item.name }}</span>
                </template>
                <template v-else-if="!item.binded">
                    <span style="color: #ddd">{{item.name}}</span>
                    <v-tooltip right>
                        <template v-slot:activator="{on}">
                            <v-btn
                                    v-on="on"
                                    @click.stop="$emit('click:bind', item)" icon>
                                <v-icon>mdi-check</v-icon>
                            </v-btn>
                        </template>
                        <span>이 유저에 해당 권한 부여</span>
                    </v-tooltip>
                </template>
                <template v-else>
                    <span>{{item.name}}</span>
                    <v-tooltip right>
                        <template v-slot:activator="{on}">
                            <v-btn
                                    v-on="on"
                                    @click.stop="$emit('click:unbind', item)" icon>
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </template>
                        <span>이 유저에서 해당 권한 제거(실제 권한이 삭제되지는 않습니다.)</span>
                    </v-tooltip>
                </template>
            </template>
        </v-treeview>
    </div>
</template>

<script>
    export default {
        name: "SystemUserPermissionTreeView",
        components: {},
        props: {
            items: {
                type: Array,
                default: () => [],
            },
            search: {
                type: String,
                default: "",
            },
            type: {
                type: String,
                default: null,
            },
        },
        data() {
            return {
                itemModel: undefined,
                itemActive: undefined,
                itemOpen: undefined,
            }
        },
        computed: {
            itemsSafe() {
                return this.items || {};
            },
        },
    }
</script>

<style scoped>

</style>